import ImageZoom from "components/imageZoom/ImageZoom";
import "./oceanBay.scss";
import oceanBayCover from "assets/img/home/oceanBay/oceanBayCover.webp";
import oceanBay1 from "assets/img/home/oceanBay/oceanBay1.webp";
import oceanBay2 from "assets/img/home/oceanBay/oceanBay2.webp";
import oceanBay3 from "assets/img/home/oceanBay/oceanBay3.webp";
import { OCEAN_BAY_ID } from "constant";
import { Link, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import productStore from "store/productStore";
import cartStore from "store/cartStore";
import { useEffect, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import { ENV } from "constant";
import authStore from "store/authStore";
import ImageSlider from "../imageSlider/ImageSlider";
import imageLoadStore from "store/imageLoadStore";

const OceanBay = () => {
  const ImageLoadStore = imageLoadStore();
  const navigate = useNavigate();

  const ProductStore = productStore();
  const AuthStore = authStore();
  const CartStore = cartStore();
  const [product, setProduct] = useState(null);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [isAddToCart, setIsAddToCart] = useState(false);

  useEffect(() => {
    fetchSpecificProductRating();
  }, []);

  const fetchSpecificProductRating = async () => {
    const product = await ProductStore.fetchOneProduct({
      _id: OCEAN_BAY_ID,
    });
    setProduct(product);
  };

  useEffect(() => {
    if (CartStore.cartProduct && product) {
      setIsAddToCart(false);
      const isCart = CartStore.cartProduct.find(
        (item) => item.productID === product._id,
      );
      if (isCart) {
        setIsAddToCart(true);
      }
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, product]);

  const AddToCart = async () => {
    if (AuthStore.isLogged) {
      setIsAddToCartLoading(true);
      await CartStore.signInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
      setIsAddToCartLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
    }

    if (ENV === "production") {
      ReactPixel.track("AddToCart", {
        content_ids: [product._id],
        content_name: product.productName,
        value: product.salePrice ? product.salePrice : product.regularPrice,
        currency: "INR",
      });
    }
    navigate("/checkout");
  };

  return (
    <div className="ocean-bay-home">
      <div className="first-container">
        <div className="image-container">
          <img src={oceanBayCover} alt="ocean-bay-perfume-background" />
        </div>

        <div className="text-container">
          <div className="text-wrapper">
            <h2>Ocean Bay</h2>
            <div className="quote-container">
              <q>The Scent of Coastal Freedom.</q>
              <p>
                Inspired by the rhythm of the tides, Ocean Bay is a fragrance
                designed for those who seek an easy, spirited life. It captures
                the essence of open waters and the refreshing clarity of a
                coastal breeze.
              </p>
            </div>
            <div className="button-container">
              <Link
                to={`/perfume/ocean-bay/${OCEAN_BAY_ID}/details`}
                className="link learn-more-link"
                onClick={() => {
                  ImageLoadStore.setImageLoading(true);
                }}
              >
                Learn More
              </Link>
              <LoadingButton
                loading={isAddToCartLoading}
                onClick={
                  isAddToCart
                    ? () => {
                        navigate("/checkout");
                      }
                    : AddToCart
                }
                className="btn btn-buy-now"
              >
                Buy Now
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      <div className="second-container">
        <div className="left-container">
          <div className="image-container">
            <div className="left-move-container">
              <div className="left-first-image img-content">
                <ImageZoom src={oceanBay2} alt="ocean-bay-first-left" />
              </div>
            </div>
            <div className="left-second-image img-content">
              <ImageZoom src={oceanBay1} alt="ocean-bay-second-left" />
            </div>
          </div>
        </div>
        <div className="right-container">
          <div className="image-container">
            <div className="right-image img-content">
              <ImageZoom src={oceanBay3} alt="ocean-bay-right" />
            </div>
          </div>
          <div className="quote-content">
            <q>
              Fresh aquatic perfume, coastal fragrance, long-lasting summer
              scent.
            </q>
          </div>
        </div>
      </div>
      <ImageSlider
        alt="ocean-bay"
        images={[oceanBay1, oceanBay2, oceanBay3]}
        quoteText={
          "Fresh aquatic perfume, coastal fragrance, long-lasting summer scent."
        }
      />
    </div>
  );
};

export default OceanBay;
